<template>
    <div class="tab-content">
        <div class="table-container-compact">
            <table class="table-compact">
                <thead>
                    <tr>
                        <th class="text-center">역할명</th>
                        <th class="text-center">코드</th>
                        <th class="text-center">상태</th>
                        <th class="text-center">설명</th>
                        <th class="text-center"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loadingRoles">
                        <td colspan="6" class="text-center"><i class="fas fa-spinner fa-spin"></i> 로딩 중...</td>
                    </tr>
                    <tr v-else-if="roles.length === 0">
                        <td colspan="6" class="text-center empty">역할이 없습니다</td>
                    </tr>
                    <tr v-else v-for="role in roles" :key="role.roleIdx">
                        <td class="text-center">{{ role.roleName }}</td>
                        <td class="text-center">
                            <span class="code-text">{{ role.roleCode }}</span>
                        </td>
                        <td class="text-center">{{ formatStatus(role.status) }}</td>
                        <td class="text-center">{{ role.remarks || "-" }}</td>
                        <td class="text-center">
                            <div class="action-buttons text-center">
                                <IconButton
                                    icon="fas fa-edit"
                                    size="small"
                                    title="수정"
                                    @click="openRoleModal('edit', role)"
                                />
                                <IconButton
                                    v-if="!role.isSystem"
                                    icon="fas fa-trash"
                                    size="small"
                                    variant="delete"
                                    title="삭제"
                                    @click="deleteRole(role)"
                                />
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <RoleFormModal v-model="roleModalVisible" :mode="roleModalMode" :form="roleForm" @save="handleSaveRole" />
    </div>
</template>

<script>
import carbonApi from "@/submodules/carbon-plugin/api";
import IconButton from "../../common/IconButton.vue";
import RoleFormModal from "../modals/RoleFormModal.vue";
import accessControlMixin from "../mixins/accessControlMixin";

export default {
    name: "RoleManagementTab",
    components: {
        IconButton,
        RoleFormModal,
    },
    mixins: [accessControlMixin],
    props: {
        roles: { type: Array, default: () => [] },
        loadingRoles: { type: Boolean, default: false },
    },
    data() {
        return {
            roleModalVisible: false,
            roleModalMode: "create",
            roleForm: {
                roleName: "",
                roleCode: "",
                remarks: "",
                sortOrder: 0,
            },
        };
    },
    methods: {
        openRoleModal(mode, role = null) {
            this.roleModalMode = mode;
            if (mode === "create") {
                this.roleForm = {
                    roleName: "",
                    roleCode: "",
                    remarks: "",
                    sortOrder: 0,
                };
            } else {
                this.roleForm = {
                    roleIdx: role.roleIdx,
                    roleName: role.roleName,
                    roleCode: role.roleCode,
                    remarks: role.remarks,
                    sortOrder: role.sortOrder,
                };
            }
            this.roleModalVisible = true;
        },

        async handleSaveRole({ payload, mode, form }) {
            try {
                if (mode === "create") {
                    const createPayload = {
                        ...payload,
                        roleCode: form.roleCode,
                        permissions: {},
                    };
                    const { data } = await carbonApi.accessControl.createRole(createPayload);
                    if (data?.success) {
                        this.toastSuccess(data.message || "역할이 추가되었습니다.");
                    }
                } else {
                    const { data } = await carbonApi.accessControl.updateRole(form.roleCode, payload);
                    if (data?.success) {
                        this.toastSuccess(data.message || "역할 정보가 수정되었습니다.");
                    }
                }
                this.roleModalVisible = false;
                this.$emit("refresh");
            } catch (error) {
                console.error("역할 저장 실패:", error);
                this.toastError(this.getErrorMessage(error, "역할 저장에 실패했습니다."));
            }
        },

        async deleteRole(role) {
            const confirmed = await this.$bvModal.msgBoxConfirm(`역할 "${role.roleName}"을 삭제하시겠습니까?`, {
                title: "역할 삭제",
                okTitle: "삭제",
                cancelTitle: "취소",
                okVariant: "danger",
            });

            if (confirmed) {
                try {
                    const { data } = await carbonApi.accessControl.deleteRole(role.roleCode);
                    if (data?.success) {
                        this.toastSuccess(data.message || "역할이 삭제되었습니다.");
                        this.$emit("refresh");
                    }
                } catch (error) {
                    console.error("역할 삭제 실패:", error);
                    this.toastError(this.getErrorMessage(error, "역할 삭제에 실패했습니다."));
                }
            }
        },
    },
};
</script>

<style scoped>
.tab-content {
    padding-top: 8px;
}
.code-text {
    padding: 2px 6px;
    background: #f1f5f9;
    color: #475569;
    border-radius: 3px;
    font-size: 11px;
}
.text-center {
    text-align: center;
}
.empty {
    padding: 30px;
    color: #94a3b8;
}
</style>
